import React from "react";
import Modal from "react-bootstrap/Modal";
import Common_Back_Btn from "../../common_components/common_back_btn/Common_Back_Btn";
import Black_Submit_Btn from "../../common_btn/black_submit_btn/Black_Submit_Btn";
import "./Delete_Modal.css";
import Gray_Btn from "../../common_btn/gray_btn/Gray_Btn";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
const Delete_Modal = ({
  show,
  onHide,
  confirmDelete
}) => {
  const navigate = useNavigate();
  const handleLogout = () => {
    Cookies.remove("ultimate_analytics_admin_security");
    navigate("/");
  };
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Delete</Modal.Title>
      </Modal.Header>

      <Modal.Body>Are you sure you want to delete this data?</Modal.Body>

      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onHide}>
          No
        </button>

        <button className="btn btn-danger" onClick={confirmDelete}>
          Yes, Delete
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Delete_Modal;
